import React from 'react';

export const Features = () => {
  return (
    <div className="max-w-6xl mx-auto glass-card p-12 rounded-2xl shadow-xl bg-white/5 backdrop-blur-sm">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-12 text-center md:text-left bg-gradient-to-r from-primary to-primary/70 text-transparent bg-clip-text">
            Why Trust Our Legal Expertise?
          </h2>
          <div className="grid gap-8">
            <div className="text-center space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
              <div className="w-16 h-16 mx-auto bg-primary/10 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white">Legal Protection</h3>
              <p className="text-gray-300">
                Your rights are protected under South African law throughout the entire process
              </p>
            </div>
            <div className="text-center space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
              <div className="w-16 h-16 mx-auto bg-primary/10 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white">Swift Results</h3>
              <p className="text-gray-300">
                Experience immediate financial relief with our efficient legal process
              </p>
            </div>
            <div className="text-center space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
              <div className="w-16 h-16 mx-auto bg-primary/10 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white">Confidential Service</h3>
              <p className="text-gray-300">
                Your information is protected by attorney-client privilege
              </p>
            </div>
          </div>
        </div>
        <div className="hidden md:block">
          <img 
            src="/lovable-uploads/ec654a44-ffcc-42af-a696-e0c750e59ecb.png" 
            alt="Celebrating success with legal expertise" 
            className="rounded-xl shadow-lg w-auto h-[600px] mx-auto object-cover opacity-80"
          />
        </div>
      </div>
    </div>
  );
};